import _styled from "styled-components";
import { useEffect } from "react";
import cn from "clsx";
import { css } from "styled-components";
import { useIsClient } from "@crehana/react-hooks";
import { useMainMenuContext, useScreenLgBreackpoint } from "../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var SubmenuBackdrop = function SubmenuBackdrop() {
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme,
    isTransparent = _useMainMenuContext.isTransparent,
    activeSubMenu = _useMainMenuContext.activeSubMenu,
    currentBreakpointKey = _useMainMenuContext.currentBreakpointKey,
    mainMenuVisibleHeight = _useMainMenuContext.mainMenuVisibleHeight,
    topBannerVisibleHeight = _useMainMenuContext.topBannerVisibleHeight,
    onChangeStateOpenOverlay = _useMainMenuContext.onChangeStateOpenOverlay;
  var isClient = useIsClient();
  var _useScreenLgBreackpoi = useScreenLgBreackpoint(),
    isLg = _useScreenLgBreackpoi.isLg,
    isEmbeddedInNewDashboard = _useScreenLgBreackpoi.isEmbeddedInNewDashboard;
  var submenuIsOpen = activeSubMenu === 'catalog-menu' || activeSubMenu === 'solutions-menu' || activeSubMenu === 'degrees-menu' || activeSubMenu === 'left-menu-drawer' || activeSubMenu === 'notifications-drawer' || activeSubMenu === 'user-menu' && currentBreakpointKey === 'sm';
  useEffect(function () {
    if (onChangeStateOpenOverlay) {
      onChangeStateOpenOverlay('CoursesExplorer', submenuIsOpen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submenuIsOpen]);
  if (!isClient || currentBreakpointKey === 'xs') {
    return null;
  }
  var themeNavZIndex = theme.nav.zIndex;
  var dynamicTopSpaceDependingOnTransparencyLg = isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.lg;
  var dynamicTopSpaceDependingOnBreakpointMd = isLg && isEmbeddedInNewDashboard ? dynamicTopSpaceDependingOnTransparencyLg : 0;
  var zIndexWhenIsMd = isLg ? themeNavZIndex - 1 : themeNavZIndex + 1;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    className: cn('fixed inset-0 pointer-events-none', theme.submenu.backdropColorClassName, submenuIsOpen ? 'cui-is-visible' : 'cui-is-hidden', {
      'pointer-events-none': !submenuIsOpen
    }),
    $_css: themeNavZIndex - 1,
    $_css2: isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.xs,
    $_css3: themeNavZIndex + 1,
    $_css4: dynamicTopSpaceDependingOnBreakpointMd,
    $_css5: zIndexWhenIsMd,
    $_css6: isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.lg,
    $_css7: themeNavZIndex - 1
  });
};
export default SubmenuBackdrop;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-16mzy5r-0"
})(["\n        backdrop-filter: blur(4px);\n        -webkit-backdrop-filter: blur(4px);\n        z-index: ", ";\n        top: ", "px;\n\n        ", " {\n          top: 0;\n          z-index: ", ";\n        }\n\n        ", " {\n          top: ", "px;\n          z-index: ", ";\n        }\n\n        ", " {\n          top: ", "px;\n          z-index: ", ";\n        }\n      "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (props) {
  return props.theme.breakpoints.up('sm');
}, function (p) {
  return p.$_css3;
}, function (props) {
  return props.theme.breakpoints.up('md');
}, function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
}, function (props) {
  return props.theme.breakpoints.up('lg');
}, function (p) {
  return p.$_css6;
}, function (p) {
  return p.$_css7;
});